module.exports = __webpack_public_path__ + "img/logo-simples.80f14d09.png";